import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.css']
})
export class TextAreaComponent extends FormElementBase {
  constructor() {
    super();
  }
}
